export default __webpack_public_path__ + "static/media/press.a9cc6a68.wav";